<div class="page-title-area">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Inicio</a></li>
        <li>Contacto</li>
      </ul>
    </div>
  </div>

  <div class="contact-area ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <div class="contact-info">
            <ul>
              <li>
                <div class="d-grid gap-2 col-md col-sm mx-1">
                  <h6>
                    <strong class="medical-activities-color"
                      >ATENCIÓN DEL AFILIADO:</strong
                    >
                  </h6>
                  <button type="button" class="default-btn">
                    <a href="tel:08103334485">
                      <i class="fas fa-phone-alt fa-sm"></i>0810-333-4485<span
                      ></span>
                    </a>
                  </button>

                  <br />
                </div>
              </li>
            </ul>

            <hr />

            <div
              class="attention-partner"
              *ngIf="this.sede && this.sede !== null"
            >
              <h3>Atención al Socio</h3>
              <ul>
                <li>
                  <div
                    class="d-grid gap-2 col-md col-sm mx-1 affiliate-headquarters"
                  >
                    <h5 style="color: #0b0f2b">
                      <strong>{{ this.sede.nombre }}</strong>
                    </h5>
                    <h6 class="headquarters-info" *ngIf="this.sede?.direccion">
                      <strong>Dirección: </strong>{{ this.sede?.direccion }}
                    </h6>
                    <h6 class="headquarters-info" *ngIf="this.sede?.email">
                      <strong>Email: </strong>{{ this.sede?.email }}
                    </h6>
                    <h6 class="headquarters-info" *ngIf="this.sede?.horario">
                      <strong>Horario: </strong>{{ this.sede?.horario }}
                    </h6>
                    <button type="button" class="default-btn">
                      <a [href]="'tel:' + this.sede.telefono1">
                        <i class="fas fa-phone-alt fa-sm"></i
                        >{{ this.sede.telefono1 }}<span></span>
                      </a>
                    </button>
                    <button
                      *ngIf="this.sede?.telefono2"
                      type="button"
                      class="default-btn"
                    >
                      <a [href]="'tel:' + this.sede?.telefono2">
                        <i class="fas fa-phone-alt fa-sm"></i
                        >{{ this.sede?.telefono2 }}<span></span>
                      </a>
                    </button>
                    <button type="button" class="default-btn">
                      <a
                        [href]="'https://wa.me/' + this.sede?.whatsapp"
                        target="_blank"
                        ><i
                          class="fab fa-whatsapp fa-lg"
                          style="color: #12e220"
                        ></i
                        >Escribinos por Whatsapp<span></span
                      ></a>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="map-section">
    <div class="container">
      <div class="map-card">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3282.958054307627!2d-58.46945512425863!3d-34.6305002729447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcc988ec57119f%3A0xb6720547b143969b!2sCulpina%2031%2C%20C1406ENA%20CABA!5e0!3m2!1ses!2sar!4v1698321668755!5m2!1ses!2sar"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </div>
</div>
